module.exports = __webpack_public_path__ + "img/braces.ef1b3f01.svg";